/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SignedConfigResponseSignature } from './signedConfigResponseSignature';
import { ComponentConfigSpec } from './componentConfigSpec';


export interface SignedConfigResponse { 
    config?: ComponentConfigSpec;
    signature?: SignedConfigResponseSignature;
}

